import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './pagination.module.less';

const Pagination = ({ pages, current, generateUrl, onClick }) => {
  // Previous page button
  let prev = '';
  if (current > 1) {
    prev = (
      <a
        href={generateUrl(current - 1)}
        className={styles.prevnext}
        onClick={onClick ? e => onClick(e, current - 1) : null}
        title="Previous page"
      >
        <Icon name="left" />
      </a>
    );
  }

  // Next page button
  let next = '';
  if (current < pages) {
    next = (
      <a
        href={generateUrl(current + 1)}
        className={styles.prevnext}
        onClick={onClick ? e => onClick(e, current + 1) : null}
        title="Next page"
      >
        <Icon name="right" isImg={false} />
      </a>
    );
  }

  // EDENG-2447: If more than 6 pages in total, there could be ellipsis
  let leftEllipses = null;
  let rightEllipses = null;
  if (pages > 6) {
    if (current >= 5) {
      leftEllipses = <span key="left-ellipses">&hellip;</span>;
    }
    if (pages - current >= 4) {
      rightEllipses = <span key="right-ellipses">&hellip;</span>;
    }
  }

  let links = [];
  // EDENG-2447:
  // 1. Always show the first and the last page
  // 2. Always show the previous one and the next one page of the current page
  // 3. Ellipsis should at least skip 2 pages.
  for (let i = 1; i <= pages; i++) {
    // Page is skipped by left ellipsis
    if (leftEllipses && i > 1 && i < current - 1 && i <= pages - 4) {
      continue;
    }
    // Page is skipped by right ellipsis
    if (rightEllipses && i >= 5 && i > current + 1 && i <= pages - 1) {
      continue;
    }

    // Add the right ellipses
    if (rightEllipses && i === pages) {
      links.push(rightEllipses);
    }

    // The actual page link
    links.push(
      <a
        key={i}
        href={generateUrl(i)}
        className={i === current ? styles.active : ''}
        onClick={onClick ? e => onClick(e, i) : null}
        title={'Page ' + i}
      >
        {i}
      </a>
    );

    // Add the left ellipses
    if (leftEllipses && i === 1) {
      links.push(leftEllipses);
    }
  }

  return (
    <div className={styles.pagination}>
      {prev}
      <div className={styles.links}>{links}</div>
      {next}
    </div>
  );
};

Pagination.displayName = 'Pagination';
Pagination.propTypes = {
  /** Number of total pages */
  pages: PropTypes.number.isRequired,
  /** Current page (starts at 0) */
  current: PropTypes.number.isRequired,
  /** Function that takes a page number and returns a URL */
  generateUrl: PropTypes.func.isRequired,
  /** Function that takes an event and page number */
  onClick: PropTypes.func,
};
Pagination.defaultProps = {
  generateUrl: () => '#',
};

export default Pagination;
